import React, { useEffect, useState } from "react";
import './RegistroVisitantesEntradas.scss';
import HeaderVisitantes from "../../../../components/molecules/HeaderVisitantes/HeaderVisitantes";
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { getAreas, getMotivos, getNombres, getUnidad, subirInformacion } from "./integracionEntradas.js";
import { ColorValidation, SubmitValidation, UpdateValue } from "../../../../utilidades/Validaciones.js";
import Swal from "sweetalert2";

const RegistroVisitantesEntradas = () => {
    const [inputList, setInputList] = useState({
        nombreOperador: { value: null, validationType: "empty" },
        unidad: { value: null, validationType: "empty" },
        area: { value: null, validationType: "empty" },
        motivos: { value: null, validationType: "empty" },
        comentarios: { value: null, validationType: "optional" },
    });

    const [nombres, setNombres] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [areas, setAreas] = useState([]);
    const [motivos, setMotivos] = useState([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getNombres(setNombres);
        getUnidad(setUnidades);
        getAreas(setAreas);
    }, []);

    useEffect(() => {
        if (inputList.motivos.value != null) {
            const inputListCopy = { ...inputList };
            inputListCopy.motivos.value = null;
            setInputList(inputListCopy);
        }
    }, [inputList.area.value]);

    useEffect(() => {
        if (inputList.area.value != null) {
            getMotivos(setMotivos, inputList.area.value?.code);
        }
    }, [inputList.area.value]);

    const cambiarOperador = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.nombreOperador.value = e.value;
        setInputList(copiaLista);
        setErrors({ ...errors, nombreOperador: false });
    };

    const cambiarUnidad = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.unidad.value = e.value;
        setInputList(copiaLista);
        setErrors({ ...errors, unidad: false });
    };

    const cambiarArea = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.area.value = e.value;
        setInputList(copiaLista);
        setErrors({ ...errors, area: false });
    };

    const cambiarMotivo = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.motivos.value = e.value;
        setInputList(copiaLista);
        setErrors({ ...errors, motivos: false });
    };

    const cambiarComentarios = (e) => {
        const copiaLista = { ...inputList };
        copiaLista.comentarios.value = e.target.value;
        setInputList(copiaLista);
    };

    useEffect(() => {
        for (const nombrePropiedad in inputList) {
            if (document.getElementById(nombrePropiedad)) {
                ColorValidation(nombrePropiedad, inputList, "empty");
            }
        }
    }, [inputList]);

    const submit = () => {
        if (SubmitValidation(inputList, setInputList)) {
            const info = {
                operador: inputList.nombreOperador.value.code,
                unidad: inputList.unidad.value.code,
                area: inputList.area.value.code,
                motivo: inputList.motivos.value.code,
                comentarios: inputList.comentarios.value,
            };

            subirInformacion(info, inputList, setInputList);
        } else {
            Swal.fire({
                icon: "error",
                title: "Complete todos los campos obligatorios",
                text: "Por favor revise los campos marcados en rojo",
            });
        }
    };

    return (
        <div className="RegistroVisitantesEntradas">
            <HeaderVisitantes seccion={"1"} />

            <div className="p-fluid">
                <Card className="formulario-card">
                    <div className="card-header">
                        <h2 className="form-title">
                            <i className="pi pi-user-plus"></i>
                            Ingrese los datos de registro
                        </h2>
                        <Message
                            severity="info"
                            text="Complete todos los campos marcados con (*)"
                            className="info-message"
                        />
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="nombreOperador" className="field-label">
                                    Nombre del Operador <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="nombreOperador"
                                    optionLabel="name"
                                    value={inputList.nombreOperador.value}
                                    options={nombres}
                                    onChange={cambiarOperador}
                                    placeholder="Seleccione su nombre"
                                    filter
                                    filterPlaceholder="Buscar nombre..."
                                    emptyMessage="No hay nombres disponibles"
                                    className={errors.nombreOperador ? 'p-invalid' : ''}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="unidad" className="field-label">
                                    Unidad <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="unidad"
                                    optionLabel="name"
                                    value={inputList.unidad.value}
                                    options={unidades}
                                    onChange={cambiarUnidad}
                                    placeholder="Seleccione su unidad"
                                    filter
                                    filterPlaceholder="Buscar unidad..."
                                    emptyMessage="No hay unidades disponibles"
                                    className={errors.unidad ? 'p-invalid' : ''}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="area" className="field-label">
                                    Área de Visita <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="area"
                                    optionLabel="name"
                                    value={inputList.area.value}
                                    options={areas}
                                    onChange={cambiarArea}
                                    placeholder="Seleccione el área"
                                    filter
                                    filterPlaceholder="Buscar área..."
                                    emptyMessage="No hay áreas disponibles"
                                    className={errors.area ? 'p-invalid' : ''}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="motivos" className="field-label">
                                    Motivo de Visita <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="motivos"
                                    optionLabel="name"
                                    value={inputList.motivos.value}
                                    options={motivos}
                                    onChange={cambiarMotivo}
                                    placeholder="Seleccione el motivo"
                                    disabled={!inputList.area.value}
                                    filter
                                    filterPlaceholder="Buscar motivo..."
                                    emptyMessage="Primero seleccione un área"
                                    className={errors.motivos ? 'p-invalid' : ''}
                                />
                                {!inputList.area.value && (
                                    <small className="help-text">
                                        Primero debe seleccionar un área
                                    </small>
                                )}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="field">
                                <label htmlFor="comentarios" className="field-label">
                                    Comentarios (opcional)
                                </label>
                                <InputTextarea
                                    id="comentarios"
                                    value={inputList.comentarios.value || ''}
                                    onChange={cambiarComentarios}
                                    placeholder="Ingrese comentarios adicionales si lo desea..."
                                    rows={4}
                                    autoResize
                                />
                            </div>
                        </div>
                    </div>

                    <div className="button-container">
                        <Button
                            label="Registrar Entrada"
                            icon="pi pi-check"
                            onClick={submit}
                            className="submit-button"
                            size="large"
                        />
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default RegistroVisitantesEntradas;
